import { SwitchHistory } from '@abrController/DataCollectors/SwitchHistory/SwitchHistory';
import { IEstimator } from '@abrController/Estimators/IEstimator';
import { EDebuggableModuleState, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import { IResolution } from '@resolutionsManager/IResolutionsManager';

export class SwitchEstimator implements IEstimator {
  public _eventBus: TEventBus;
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public additionalInfo: TDebuggableAdditionalInfo = { bannedResolution: [] };
  public groups: string[] = ['abr'];

  private readonly _switchHistory: SwitchHistory;

  constructor(eventBus: TEventBus) {
    this._eventBus = eventBus;
    this._switchHistory = new SwitchHistory(this._eventBus);
  }

  public reset(): void {
    this._switchHistory.reset();
  }

  public destroy(): void {
    this._switchHistory.destroy();
  }

  public getNextEstimatedResolution(availableDecreasingResolutions: IResolution[]): IResolution | null {
    const bannedResolutionsName: string[] = this._switchHistory.getBannedResolutions().map(({ name }) => name);
    this.additionalInfo.bannedResolution = bannedResolutionsName;
    return availableDecreasingResolutions.find(({ name }) => !bannedResolutionsName.includes(name)) || null;
  }
}
